import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import { getCountryCallingCode } from "react-phone-number-input/input";
import { getSortedCountries } from "../../../utils/phone";

const CountrySelect = ({ value, onChange, labels, language, ...rest }) => {
  const sortedCountries = useMemo(() => {
    return getSortedCountries(labels, language);
  }, [labels, language]);

  return (
    <Form.Select
      {...rest}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="custom-input"
    >
      {sortedCountries.map((country) => (
        <option key={country} value={country}>
          {labels[country]} +{getCountryCallingCode(country)}
        </option>
      ))}
    </Form.Select>
  );
};

export default CountrySelect;